// extracted by mini-css-extract-plugin
module.exports = {"chip":"Chip_chip__Z738E","chipLabel":"Chip_chipLabel__Ey_Mh","chipClose":"Chip_chipClose__NM_Ed","chipDeleteContainer":"Chip_chipDeleteContainer__FXq9z"};